import React from 'react';
import { Grid, Button, Box } from '@mui/material';

function NumericPad({ onClick, disabled, emoji }) {
  // Arrange keys in the custom order
  const layout = [
    [0],
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [10, 20, 30],
  ];
  const layout1 = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
    [10, 11],
  ];

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <Grid container spacing={1} sx={{ maxWidth: '400px', margin: '0 auto' }}>
        {layout.map((row, rowIndex) => (
          <Grid container item spacing={1} justifyContent="center" key={rowIndex}>
            {row.map((key) => (
              <Grid item key={key}>
                <Button
                  variant="contained"
                  onClick={() => onClick(key)}
                  fullWidth
                  disabled={disabled}
                  sx={{
                    width: '50px', // Slightly bigger buttons
                    height: '50px',
                    fontSize: '2rem', // Bigger numbers
                    fontWeight: 'bold', // Bold text
                    padding: '15px 0', // Larger touch area
                  }}
                >
                  {key}
                </Button>
              </Grid>
            ))}
          </Grid>
        ))}
      </Grid>

      {/* Feedback Emoji Overlay */}
      {emoji && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '3rem',
            textAlign: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '50%',
            width: '100px',
            height: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
          }}
        >
          {emoji}
        </Box>
      )}
    </Box>
  );
}

export default NumericPad;
